import axios from "axios";
import { useState, useMemo, useEffect } from "react";
const WEEKDAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function daysInMonth(year, monthIndex) {
  return new Date(year, monthIndex + 1, 0).getDate();
}
function weekdayMondayFirst(year, monthIndex, day) {
  const d = new Date(year, monthIndex, day);
  const w = d.getDay(); // 0=Sun..6=Sat
  return (w + 6) % 7; // Monday-first
}

/* Component */
export default function ComplianceOverview() {
  // calendar state
  const today = new Date();
  const [cal, setCal] = useState({
    year: today.getFullYear(),
    month: today.getMonth(),
  });

  // modal state (selected day)
  const [selectedDay, setSelectedDay] = useState(null); // { year, month, day }
  const [selectedEvents, setSelectedEvents] = useState([]);

  function changeMonth(delta) {
    let { year, month } = cal;
    month += delta;
    if (month < 0) {
      month = 11;
      year -= 1;
    } else if (month > 11) {
      month = 0;
      year += 1;
    }
    setCal({ year, month });
  }

  const { year, month } = cal;

  const dim = daysInMonth(year, month);
  const firstWeekday = weekdayMondayFirst(year, month, 1); // 0..6
  const totalCells = Math.ceil((firstWeekday + dim) / 7) * 7;
  const cells = Array.from({ length: totalCells }).map((_, idx) => {
    const dayNumber = idx - firstWeekday + 1;
    return dayNumber >= 1 && dayNumber <= dim ? dayNumber : null;
  });

  function closeModal() {
    setSelectedDay(null);
    setSelectedEvents([]);
  }





  const [data, setData] = useState([]);
  const tabsList = [
    { label: "All", value: "All" },
    { label: "GST", value: "GST" },
    { label: "TDS", value: "TDS" },
    { label: "ROC", value: "ROC" },
    { label: "Income Tax", value: "Income Tax" }
  ];
  const [activeTab, setActiveTab] = useState("All");

  const filteredDetails =
    activeTab === "All"
      ? data
      : data.filter(
        (item) =>
          item.category?.toLowerCase() === activeTab.toLowerCase()
      );

  const getCalendarData = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/calendar`);
      if (res.status === 200) {
        setData(res.data.data);
      } else {
        setData([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getCalendarData();
  }, []);

  const openDay = (day) => {
    setSelectedDay({ day, month, year });
    setSelectedEvents(monthEvents[day] || []);
  };

  const monthEvents = useMemo(() => {
    const events = {};

    data.forEach((item) => {
      if (!item.dueDate) return;

      const [dayStr] = item.dueDate.split("-");
      const day = parseInt(dayStr, 10);

      if (!events[day]) {
        events[day] = [];
      }

      events[day].push({
        title: item.compliance,
        category: item.category,
        act: item.act,
        notes: item.notes,
      });

    });

    return events;
  }, [data]);



  return (
    <section
      className="compliance-section"
      aria-label="Compliance overview with calendar"
    >
      <p
        className="compliance-subtitle"
        style={{
          color: "#00385f",
          textAlign: "center",
          fontWeight: "700",
          fontSize: "18px"
        }}
      >
        Compliance Calendar — Admin can manage and add compliance schedules here.
        Important due dates and upcoming compliances for the current month will be displayed.
      </p>

      <div className="container compliance-container">
        {/* LEFT: Details (tabs + table) */}
        <div className="details-card" aria-label="Compliance details">
          <div
            role="tablist"
            aria-label="Compliance categories"
            className="tabs-row"
          >
            <div className="tabs">
              {tabsList.map((t) => (
                <button
                  key={t.value}
                  type="button"
                  role="tab"
                  aria-selected={activeTab === t.value}
                  className={`tab-btn ${activeTab === t.value ? "active" : ""}`}
                  onClick={() => setActiveTab(t.value)}
                >
                  {t.label}
                </button>
              ))}
            </div>

          </div>

          <div className="table-header">
            <div className="th">COMPLIANCE</div>
            <div className="th">APPLICABILITY</div>
            <div className="th">PERIOD</div>
            <div className="th">DUE DATE</div>
            <div className="th">ACT</div>
            <div className="th">NOTES</div>
          </div>

          <div className="details-content">
            {filteredDetails.length > 0 ? (
              filteredDetails.map((row, index) => (
                <div className="table-row" key={index}>
                  <div className="td">{row.compliance}</div>
                  <div className="td">{row.applicability}</div>
                  <div className="td">{row.period}</div>
                  <div className="td">
                    <strong>{row.dueDate}</strong>
                  </div>
                  <div className="td">{row.act}</div>
                  <div className="td">{row.notes}</div>
                </div>
              ))
            ) : (
              <p className="text-center">No data found</p>
            )}
          </div>


        </div>

        {/* RIGHT: Calendar */}
        <div className="glance-card" aria-label="Glance & calendar">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginTop: 6,
              margin: "0 18px 0 0",
            }}
          >
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <button
                className="tab-btn"
                type="button"
                onClick={() => changeMonth(-1)}
                aria-label="Prev month"
              >
                ‹
              </button>
              <div style={{ fontWeight: 800, color: "#0f4e71", fontSize: 16 }}>
                {MONTH_NAMES[month]} {year}
              </div>
              <button
                className="tab-btn"
                type="button"
                onClick={() => changeMonth(+1)}
                aria-label="Next month"
              >
                ›
              </button>
            </div>
            <div style={{ fontWeight: 800, color: "#103f57" }}>SDPM</div>
          </div>

          <div className="sm-scroll" style={{ marginTop: 12 }}>
            <div className="sm-grid" role="grid" aria-label="Month calendar">
              {WEEKDAY_LABELS.map((wd) => (
                <div key={wd} className="sm-wd" role="columnheader">
                  {wd}
                </div>
              ))}

              {cells.map((d, idx) => {
                const evs = d ? monthEvents[d] || [] : [];
                return (
                  <button
                    key={idx}
                    type="button"
                    className={`sm-cell ${d ? "has-day" : "empty"} ${evs.length ? "has-events" : ""
                      }`}
                    onClick={() => d && openDay(d)}
                    aria-label={d ? `Open ${MONTH_NAMES[month]} ${d}` : "Empty"}
                  >
                    {d ? (
                      <>
                        <div className="sm-num">
                          {String(d).padStart(2, "0")}
                        </div>
                        <div className="sm-events">
                          {evs.map((e, i) => (
                            <div
                              key={i}
                              className={`sm-event sm-${e.category?.toLowerCase()}`}
                              title={`${e.title} (${e.act})`}
                            >
                              {e.title}
                            </div>
                          ))}

                        </div>
                      </>
                    ) : null}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {selectedDay && (
        <div
          className="modal-backdrop"
          onClick={closeModal}
          role="dialog"
          aria-modal="true"
        >
          <div className="day-modal" onClick={(e) => e.stopPropagation()}>
            <div className="day-modal-header">
              <div>
                <div className="day-modal-date">
                  {MONTH_NAMES[selectedDay.month]} {selectedDay.day},{" "}
                  {selectedDay.year}
                </div>
              </div>

              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <button className="modal-close-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>

            <div className="day-modal-body">
              <div className="day-modal-body">
                {selectedEvents.length === 0 ? (
                  <div className="day-empty">No events for this day</div>
                ) : (
                  selectedEvents.map((ev, i) => (
                    <div key={i} className="day-event-card">
                      <div className="day-event-title">{ev.title}</div>

                      <div className="day-event-meta">
                        <span>{ev.category}</span> • <span>{ev.act}</span>
                      </div>

                      {ev.notes && (
                        <div className="day-event-notes">{ev.notes}</div>
                      )}
                    </div>
                  ))
                )}
              </div>

            </div>

            <div className="day-modal-footer">
              <button className="pill" onClick={closeModal}>
                Done
              </button>
            </div>
          </div>
        </div>
      )}

    </section>
  );
}
